<template>
  <div>
    <v-bottom-navigation
      color="info"
      horizontal
      :background-color="colorfrist"
      dark
    >
      <v-btn to="/admin/gov_em/period_mgovem">
        <span>กำหนดการ </span>
        <v-icon>mdi-numeric-0-box</v-icon>
      </v-btn>

      <v-btn to="/admin/gov_em/Governmentemployeereportadmin">
        <span>รายงานกรอบอัตรากำลัง สถานศึกษา</span>
        <v-icon>mdi-source-branch</v-icon>
      </v-btn>

      <v-btn to="/admin/gov_em/government_employee">
        <span>กรอบอัตรากำลัง </span>
        <v-icon>mdi-source-branch</v-icon>
      </v-btn>      
    </v-bottom-navigation>
  </div>
</template>

<script>
export default {
  name: "HRvecMovementmenu",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
  computed: {
    colorfrist() {
      return "#8F17B0FF";
    },
    colorsecord() {
      return "#280606FF";
    }
  }
};
</script>

<style lang="scss" scoped></style>
